import { render, staticRenderFns } from "./dialog-approve-normal.vue?vue&type=template&id=b50b31d8&scoped=true&"
import script from "./dialog-approve-normal.vue?vue&type=script&lang=js&"
export * from "./dialog-approve-normal.vue?vue&type=script&lang=js&"
import style0 from "./dialog-approve-normal.vue?vue&type=style&index=0&id=b50b31d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b50b31d8",
  null
  
)

export default component.exports